import { useContext, useState } from "react";

import { useQuery } from "@apollo/client";

import { FETCH_RATINGS_SUMMARY_BY_RECIPE_ID } from "../../../app/graphql/queries";
import { RatingSummary } from "../../../app/recipePage/recipePage.types";
import { ErrorManagementContext } from "../../../utils/errorManagement/ErrorManagementProvider";

const useRatingSummary = (recipeId: string) => {
  const [ratingsSummary, setRatingSummary] = useState<RatingSummary>({
    avgRating: 0,
    ratingCount: 0,
    feedbacks: []
  });

  const variables = { recipeId };
  const { cookClubLog } = useContext(ErrorManagementContext);

  const { loading: ratingsLoading } = useQuery(FETCH_RATINGS_SUMMARY_BY_RECIPE_ID, {
    variables,
    onCompleted: (data) => {
      const ratingsSummaryData = data?.ratingsSummaryLast60DaysView?.[0];
      setRatingSummary({
        avgRating: ratingsSummaryData.rating_avg,
        ratingCount: ratingsSummaryData.rating_count,
        feedbacks: ratingsSummaryData.top_feedback
      });
    },
    onError: (err) => {
      cookClubLog(
        "",
        "Unable to fetch Ratings!",
        '',
        { ui: { type: "error" }, browserConsole: true })
      console.log('Error fetching the ratings:', err);
    }
  })

  return { ratingsSummary, loading: ratingsLoading };
};

export default useRatingSummary;